import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
      <div className="bg-gradient-to-r from-[#1E3A5F] to-[#2563EB] rounded-3xl p-10 md:p-16 text-center text-white">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          지금 바로 상담을 시작하세요
        </h2>
        <p className="text-slate-200 mb-8 max-w-xl mx-auto leading-relaxed">
          원장 직강, 개별 맞춤 수업으로 수학 자신감을 키워드립니다.<br />
          전화 또는 방문 상담 모두 가능합니다.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <a
            href="tel:010-2368-3385"
            className="inline-flex items-center justify-center whitespace-nowrap h-11 px-8 bg-[#F59E0B] hover:bg-[#D97706] text-[#1E3A5F] font-bold rounded-lg text-sm transition-colors cursor-pointer gap-2"
          >
            <i className="ri-phone-line" />
            010-2368-3385
          </a>
          <Link
            to="/location"
            className="inline-flex items-center justify-center whitespace-nowrap h-11 px-8 bg-transparent border border-white text-white hover:bg-white/10 rounded-lg text-sm font-medium transition-colors cursor-pointer"
          >
            오시는 길 보기
          </Link>
        </div>
        <div className="flex flex-wrap justify-center gap-6 mt-8 text-sm text-slate-200">
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-[#F59E0B]" />
            원장 직강 보장
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-[#F59E0B]" />
            개별 맞춤 수업
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-[#F59E0B]" />
            중·고등부 전문
          </span>
        </div>
      </div>
    </section>
  );
}
